<template>
  <material-card
    class="v-card--material-stats"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-card
      slot="offset"
      :class="`elevation-${elevation}`"
      :color="color"
      class="pa-3"
      dark
    >
     <v-btn text icon to>
      <v-icon size="40">
        {{ icon }}
      </v-icon>
      </v-btn>
    </v-card>

    <div class="text-left">
      <!-- <p
        class="body-2 grey--text font-weight-light mb-0"
        v-text="title"
      /> -->
     <h3 class="font-weight: 200;">
        {{ titvalue }} <small>{{ smallValue }}</small>
      </h3>
    </div>

 

  
  </material-card>
</template>

<script>
  import Card from './Card'

  export default {
    name: 'MaterialStatsCard',

    inheritAttrs: false,
  data: () => ({
      step: 1,
    }),
    props: {
      ...Card.props,
      icon: {
        type: String,
        required: true
      },
      subIcon: {
        type: String,
        default: undefined
      },
      subIconColor: {
        type: String,
        default: undefined
      },
      subTextColor: {
        type: String,
        default: undefined
      },
      subText: {
        type: String,
        default: undefined
      },
      title: {
        type: String,
        default: undefined
      },
      titvalue: {
        type: String,
        default: undefined
      },
      smallValue: {
        type: String,
        default: undefined
      },
      tot:{
        type: String,
        default: undefined
      }
    }
  }
</script>

<style lang="scss">
.v-card--material-stats {
  display: flex;
  flex-wrap: wrap;
  position: relative;
   margin-right:15px ;

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: auto;
    padding: 10px 16px 10px;
  }

  .v-card {
    border-radius: 8px;
    flex: 0 1 auto;
   
  }

  .v-card__text {
    display: inline-block;
    flex: 1 0 calc(90% - 70px);
    position: right;
    top: 0;
    right: 0;
    width: 85%;
  }

  .v-card__actions {
    flex: 1 0 100%;
  }
}
</style>
